// @ts-ignore
import pkg from '../../../../package.json';
const { version, name } = pkg;
export default class Configs {
  static readonly pagination = {
    startPage: 1,
    defaultSize: 25,
    sizeOptions: [10, 25, 50, 100],
    listAll: -1,
  };

  static readonly hq = {
    timezone: 'America/New_York',
    countryCode: 'US',
  };

  static readonly format = {
    date: 'MM/DD/YYYY',
    time: 'h:mm a',
    dateTime: 'MM/DD/YYYY h:mm a',
    serverLocalDate: 'YYYY-MM-DD',
    serverLocalDateTime: 'YYYY-MM-DDTHH:mm:ss',
    pickerTime: 'h:mm a'
  };

  static readonly version = version;
  static readonly appName = name;

  static readonly maxDistance = 50;
}
